<template>
  <div
    class="create-guid-steps-container"
    :class="{
      [`create-guid-steps-container--${createRenderType}`]: true,
    }"
  >
    <div class="create-guid-steps" v-show="!createEditGuidTourVisible">
      <div class="cgs-item flex">
        <label class="cgsi-label">
          {{ $$tValue("create.step_index", { index: 1 }) }}
        </label>
        <div class="cgsi-main">
          <div class="cgsi-title">
            {{ $$t("create.guid_write_lyrics") }}
          </div>
          <div class="cgsi-content">
            {{ $$t("create.guid_write_lyrics_content").split("[button]")[0] }}
            <span class="cgsi-content-op cgsi-ai-lirics" v-if="$$t('create.guid_write_lyrics_content').includes('[button]')">
              <Button
                :renderStyle="{
                  '--padding': '0',
                  '--width': '100px',
                  '--height': '32px',
                  '--borderRadius': '50px',
                  '--background': 'rgba(255, 255, 255, 0.1)',
                  '--fontColor': '#fff',
                  '--fontSize': '12px',
                  '--fontWeight': 'normal',
                  '--border': 'none',
                  '--backgroundHover': 'rgba(255, 255, 255, 0.2)',
                  '--fontColorHover': '#fff',
                }"
              >
                <span class="block">{{
                  $$t("create.lyrics_about").replace("{song_title}", "")
                }}</span>
              </Button>
            </span>
            {{ $$t("create.guid_write_lyrics_content").split("[button]")[1]??'' }}
          </div>
        </div>
      </div>
      <div class="cgs-item flex">
        <label class="cgsi-label">
          {{ $$tValue("create.step_index", { index: 2 }) }}
        </label>
        <div class="cgsi-main">
          <div class="cgsi-title">
            {{ $$t("create.guid_edit_idea") }}
          </div>
          <div class="cgsi-content">
            {{ $$t("create.guid_edit_idea_content") }}
          </div>
        </div>
      </div>
      <div class="cgs-item flex">
        <label class="cgsi-label">
          {{ $$tValue("create.step_index", { index: 3 }) }}
        </label>
        <div class="cgsi-main">
          <div class="cgsi-title">
            {{ $$t("create.guid_create_song") }}
          </div>
          <div class="cgsi-content">
            {{ $$t("create.guid_create_song_content").split("[button]")[0] }}
            <span class="cgsi-content-op">
              <Button
                :renderStyle="{
                  '--padding': '0',
                  '--width': '80px',
                  '--height': '32px',
                  '--borderRadius': '48px',
                  '--background':
                    'linear-gradient(97deg, rgba(79, 222, 255, 1) 0%, rgba(230, 117, 255, 1) 99%)',
                  '--fontColor': '#000',
                  '--fontSize': '14px',
                  '--fontWeight': '500',
                  '--border': 'none',
                  '--backgroundHover':
                    'linear-gradient(97deg, rgba(79, 222, 255, 0.75) 0%, rgba(230, 117, 255, 0.75) 99%)',
                  '--fontColorHover': '#000',
                }"
              >
                <span>{{ $$t("create.create") }}</span>
              </Button>
            </span>
            {{ $$t("create.guid_create_song_content").split("[button]")[1] }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {
  ref,
  defineProps,
  defineEmits,
  computed,
  readonly,
  reactive,
  watch,
  defineExpose,
  onMounted,
  onUpdated,
  onUnmounted,
} from "vue";
import { storeToRefs } from "pinia";

import {
  $$language,
  $$t,
  $$tValue,
} from "@/i18n/i18n.js";

import Button from "@/components/basic/button/Button.vue";

import useCreateLayoutStore from "@/store/create/createLayoutStore.js";
const createLayoutStore = useCreateLayoutStore();

const { createRenderType, isShowFeedCreateGuid, createEditGuidTourVisible } =
  storeToRefs(createLayoutStore);

const props = defineProps({});
const emits = defineEmits([]);
const renderData = reactive({});

onMounted(() => {});
</script>
<style lang="scss">
.create-guid-steps-container {
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  .create-guid-steps {
    text-align: left;
    max-width: 630px;
    width: 100%;
    padding: 20px 20px;
    max-height: 100%;
    overflow-y: auto;
    .cgs-item {
      &:not(:first-child) {
        margin-top: 24px;
      }
    }
    .cgsi-label {
      width: 90px;
      min-width: 90px;
      font-family: HarmonyOS Sans SC;
      font-size: 24px;
      font-weight: bold;
      line-height: 28px;

      background: linear-gradient(112deg, #4fdeff 0%, #e675ff 100%);
      color: transparent;
      background-clip: text;
    }
    .cgsi-title {
      font-family: HarmonyOS Sans SC;
      font-size: 24px;
      font-weight: bold;
      line-height: normal;
      color: #ffffff;
      line-height: 28px;
    }
    .cgsi-main {
      flex: 1 1 0;
    }
    .cgsi-content {
      border-radius: 12px;
      margin-top: 16px;
      padding: 16px 20px;
      background: rgba(255, 255, 255, 0.1);

      font-family: HarmonyOS Sans SC;
      font-size: 16px;
      font-weight: 500;
      line-height: 28px;
      color: #ffffff;
    }
    .cgsi-content-op {
      display: inline-block;
      margin: 0 4px;
      .el-button {
        pointer-events: none;
      }
      &.cgsi-ai-lirics {
        i {
          height: 16px;
          width: 16px;
          background-color: rgba(255, 255, 255, 0.5);
          background: url(/src/assets/img/lyric-whole-ico.png);
          background-size: cover;
        }
      }
    }
  }
  &.create-guid-steps-container--mobile {
    .create-guid-steps {
      text-align: left;
      max-width: 462px;
      width: 100%;
      padding: 20px 20px 100px 20px;
    }
  }
}
</style>
